/**
 * The offer enums, in a module of their own rather than beside the Zod
 * schemas they feed.
 *
 * This split is a bundle decision, not a taste one. `offers.route.search.ts`
 * needs `JOB_OFFER_STATUSES` to validate the status search param, and
 * `router.tsx` imports every route's search schema EAGERLY (a search schema
 * cannot be lazy: it runs before the route component loads). While the tuple
 * lived in `offer.schema.ts`, that eager edge dragged the whole offer schema
 * module, every form message included, into the initial chunk of an app most
 * of whose users never open this page. Four string tuples cost bytes nobody
 * notices; a zod module costs about a kilobyte gzipped against a 150 KB
 * budget.
 */

/// The four the shore's `JOB_OFFER_STATUSES` names, in its order.
export const JOB_OFFER_STATUSES = [
  "awaiting_response",
  "accepted",
  "rejected",
  "withdrawn",
] as const;

export type JobOfferStatus = (typeof JOB_OFFER_STATUSES)[number];

/// What an admin may record. `awaiting_response` is absent on purpose: an
/// offer is never un-answered (shore decision 13, recording is an admin act).
export const OFFER_RESPONSES = ["accepted", "rejected", "withdrawn"] as const;

export type OfferResponse = (typeof OFFER_RESPONSES)[number];

/// Thirty rows is a long offer letter already; the shore caps at the same
/// number, so a form that let somebody type a 31st would only earn them a 400.
export const OFFER_TERMS_MAX_ROWS = 30;
